/**
 * Decodes an unverified JWT payload in the browser.
 *
 * This is only for routing and form prefill. Authorization remains
 * server-side.
 */
export function decodeJwtPayload<T extends object>(token: string): T | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const bytes = Uint8Array.from(atob(padded), (character) =>
      character.charCodeAt(0),
    );
    const decoded: unknown = JSON.parse(new TextDecoder().decode(bytes));

    if (
      decoded === null ||
      typeof decoded !== "object" ||
      Array.isArray(decoded)
    ) {
      return null;
    }

    return decoded as T;
  } catch {
    return null;
  }
}
